import { render, staticRenderFns } from "./QuarterSwitch.vue?vue&type=template&id=2c5717f8&scoped=true&"
import script from "./QuarterSwitch.vue?vue&type=script&lang=ts&"
export * from "./QuarterSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./QuarterSwitch.vue?vue&type=style&index=0&id=2c5717f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5717f8",
  null
  
)

export default component.exports